import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackEntityTeaserShow } from './tracking';
import { FavoriteEntity } from '../../components/FavoriteEntity';
import { selectFilters, selectIsEntitySelected } from '../../selectors';
import { selectOptions } from '../../selectors/print';
import { EEntityType } from '../../types/filters';
import { IFavoriteEntity } from '../../types/results';
import { CheckboxContainer } from '../CheckboxContainer/CheckboxContainer';

export interface IProps {
  favoriteEntity: IFavoriteEntity;
  position: number;
  isEditComment: boolean;
  isFetchingComment: boolean;
  isSearcherOrSub: boolean;
}

export function FavoriteEntityContainer(props: IProps) {
  const { favoriteEntity, position } = props;
  const { entityId, entityType } = favoriteEntity;
  const isHideForPrint = useSelector(selectIsEntitySelected(entityId, entityType));
  const printOptions = useSelector(selectOptions);
  const filters = useSelector(selectFilters);

  const handleEntityTrackTeaserShow = React.useCallback(() => {
    if (filters.favoriteEntityType === EEntityType.Newbuilding) {
      return;
    }

    trackEntityTeaserShow(entityId, position);
  }, [entityId, filters.favoriteEntityType, position]);

  return (
    <ActionAfterViewObserver
      percentVisible={0.5}
      callback={handleEntityTrackTeaserShow}
      triggerOnce={false}
      callbackDelay={1000}
    >
      <FavoriteEntity
        {...props}
        isHideForPrint={!isHideForPrint}
        printComments={printOptions.printNotes}
        checkbox={<CheckboxContainer favoriteEntity={favoriteEntity} />}
      />
    </ActionAfterViewObserver>
  );
}
